import { useQuery } from "@tanstack/react-query";
import { bankRepository } from "../repositories/bankRepository";

export const bankAccountsQueryKey = () => ["bank", "accounts"] as const;

interface UseBankAccountsQueryOptions {
  enabled?: boolean;
}

export function useBankAccountsQuery(
  options: UseBankAccountsQueryOptions = {},
) {
  const { enabled = true } = options;
  const query = useQuery({
    queryKey: bankAccountsQueryKey(),
    queryFn: () => bankRepository.getBankAccountsOptions(),
    enabled,
    staleTime: 1000 * 60 * 15, // 15 minutes
    gcTime: 60 * 60 * 1000, // Cache for 1 hour
    refetchOnMount: "always", // Refetch on every mount
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetchBankAccounts: query.refetch,
    isSuccess: query.isSuccess,
    isError: query.isError,
  };
}
